/** Onboarding questionnaire + recommendation API. */
import { request } from "./http";
import type { OnboardingAnswers } from "./types";

export interface Recommendation {
  level: string;
  kind: string;
  pack_code: string;
  headline: string;
  reason: string;
  add_credits: string | null;
}

export interface OnboardingState {
  onboarded: boolean;
  answers: OnboardingAnswers;
  recommendation: Recommendation | null;
}

/** The completed questionnaire — every field required before we submit. */
export interface OnboardingSubmission {
  goal: string;
  level: string;
  target_level: string;
  board: string;
  timeline: string;
}

export function getOnboarding(): Promise<OnboardingState> {
  return request("/onboarding");
}

export function submitOnboarding(answers: OnboardingSubmission): Promise<Recommendation> {
  return request("/onboarding", { method: "POST", body: answers });
}
